import Header from '../header';
import styles from '../../styles/main.module.css';
import { useEffect, useState } from 'react';
import { useInitializeMFEProvider } from '../../../app/providers/mfe.provider';
import { useRouter } from 'next/router';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { Row } from '@storable/react-library';
import { Col } from '@storable/react-library';
import { Spinner } from '@storable/react-library';

const excludedHeaderRoutes = ['/views', '/verify/ach'];

function Layout(props: { children: any }) {
    const [showNavBar, setShowNavBar] = useState(false);
    const [availableToken, setAvailableToken] = useState<string | undefined>(
        undefined
    );
    const router = useRouter();
    const isNotificationBanner = router.pathname.includes(
        '/notification_banner'
    );
    const { standAloneMode, mfeHostToken } = useInitializeMFEProvider(
        undefined,
        undefined,
        setAvailableToken,
        isNotificationBanner ? 0 : undefined
    );
    useEffect(() => {
        // page has loaded and is within an iframe
        if (
            standAloneMode &&
            !excludedHeaderRoutes.some((route) =>
                router.pathname.includes(route)
            )
        ) {
            setShowNavBar(true);
        }
    }, [standAloneMode]);

    const handleChildProps = () => {
        if (
            !showNavBar &&
            !availableToken &&
            !router.pathname.includes('/views') &&
            !router.pathname.includes('/verify/ach')
        ) {
            return (
                <Row>
                    <Col xs={4}></Col>
                    <Col
                        xs={4}
                        className="d-flex justify-content-center align-items-center"
                    >
                        <Spinner animation="border" />
                    </Col>
                    <Col xs={4}></Col>
                </Row>
            );
        }
        return <div className={styles.mainContainer}>{props.children}</div>;
    };

    return (
        <>
            <Header showNavBar={showNavBar} />
            {handleChildProps()}
        </>
    );
}

export default Layout;
